import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-between" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "mt-28 mb-2 flex justify-center" }
const _hoisted_10 = { class: "w-8" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mb-40 text-center" }, "Fetching ideas...", -1)
const _hoisted_12 = {
  key: 1,
  class: "mt-8"
}
const _hoisted_13 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_14 = {
  key: 1,
  class: "flex flex-row justify-center my-16"
}
const _hoisted_15 = { class: "mb-6" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { key: 2 }
const _hoisted_18 = {
  key: 1,
  class: "text-base text-center my-28"
}
const _hoisted_19 = { class: "flex justify-end items-center py-3" }
const _hoisted_20 = {
  key: 0,
  class: "text-base text-cebai-grey-dark leading-snug pr-2 mr-auto"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:block" }, " You must select at least one idea to create a plan ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "sm:hidden" }, " Select at least one idea to create a plan ", -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = {
  key: 1,
  class: "text-base text-cebai-grey-dark leading-snug pr-2 mr-auto"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, " Are you sure you want to delete these ideas? This can't be undone. ", -1)
const _hoisted_26 = { class: "flex justify-center mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectAllIcon = _resolveComponent("SelectAllIcon")!
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")!
  const _component_BinIcon = _resolveComponent("BinIcon")!
  const _component_Ribbon = _resolveComponent("Ribbon")!
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!
  const _component_GuidancePrompts = _resolveComponent("GuidancePrompts")!
  const _component_Guidance = _resolveComponent("Guidance")!
  const _component_ChallengeIdea = _resolveComponent("ChallengeIdea")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_ContentBlock = _resolveComponent("ContentBlock")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_AppButtonRouterLink = _resolveComponent("AppButtonRouterLink")!
  const _component_Editorial = _resolveComponent("Editorial")!
  const _component_ModalContent = _resolveComponent("ModalContent")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Download = _resolveComponent("Download")!
  const _component_CreateIdea = _resolveComponent("CreateIdea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Ribbon, {
      class: "mt-16",
      "ribbon-type": "grey"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("ul", _hoisted_2, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                id: "button-all-ideas",
                class: _normalizeClass(["py-4 px-2 text-lg mr-2 font-robotoMedium", {
              'text-cebai-base-dark border-b-4 border-b-cebai-primary':
                !_ctx.showFavouritesOnly,
              'text-cebai-grey-dark hover:text-cebai-base-dark':
                _ctx.showFavouritesOnly,
            }]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShowFavouritesOnly && _ctx.toggleShowFavouritesOnly(...args)))
              }, " All Ideas ", 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: _normalizeClass(["py-4 px-2 text-lg mr-2 font-robotoMedium", {
              'text-cebai-base-dark border-b-4 border-b-cebai-primary':
                _ctx.showFavouritesOnly,
              'text-cebai-grey-dark hover:text-cebai-base-dark':
                !_ctx.showFavouritesOnly,
            }]),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleShowFavouritesOnly && _ctx.toggleShowFavouritesOnly(...args)))
              }, " Favourites ", 2)
            ])
          ]),
          _createElementVNode("ul", _hoisted_3, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: _normalizeClass(["flex items-center py-4 px-1.5 sm:px-2 text-base mr-2 whitespace-nowrap", {
              'text-cebai-grey-dark hover:text-cebai-base-dark':
                _ctx.hasIdeas && !_ctx.hasEditedIdeas,
              'text-cebai-grey-mid': !_ctx.hasIdeas || _ctx.hasEditedIdeas,
            }]),
                disabled: !_ctx.hasIdeas || _ctx.hasEditedIdeas,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSelectAllClick && _ctx.handleSelectAllClick(...args)))
              }, [
                _createVNode(_component_SelectAllIcon, { class: "flex-none fill-current mr-2" }),
                (_ctx.hasSelectedAll)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Deselect all "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, " Select all "))
              ], 10, _hoisted_4)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                id: "button-download-ideas",
                class: _normalizeClass(["flex items-center py-4 px-1.5 sm:px-2 text-base mr-2", {
              'text-cebai-grey-dark hover:text-cebai-base-dark':
                _ctx.hasSelectedIdeas && !_ctx.hasEditedIdeas,
              'text-cebai-grey-mid': !_ctx.hasSelectedIdeas || _ctx.hasEditedIdeas,
            }]),
                disabled: !_ctx.hasSelectedIdeas || _ctx.hasEditedIdeas,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showDownloadIdeasModal && _ctx.showDownloadIdeasModal(...args)))
              }, [
                _createVNode(_component_DownloadIcon, { class: "stroke-current stroke-[1.5px] mr-2" }),
                _createTextVNode(" Download ")
              ], 10, _hoisted_7)
            ]),
            _createElementVNode("li", null, [
              (_ctx.challengeIsActive)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: _normalizeClass(["flex items-center py-4 px-1.5 sm:px-2 text-base", {
              'text-cebai-grey-dark hover:text-cebai-base-dark':
                _ctx.hasSelectedIdeas && !_ctx.hasEditedIdeas,
              'text-cebai-grey-mid': !_ctx.hasSelectedIdeas || _ctx.hasEditedIdeas,
            }]),
                    disabled: !_ctx.hasSelectedIdeas || _ctx.hasEditedIdeas,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showDeleteIdeasModal && _ctx.showDeleteIdeasModal(...args)))
                  }, [
                    _createVNode(_component_BinIcon, { class: "fill-current mr-2" }),
                    _createTextVNode(" Delete ")
                  ], 10, _hoisted_8))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ContentBlock, null, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_LoadingIcon)
                ])
              ]),
              _hoisted_11
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_ctx.hasIdeas)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.hasGuidance && _ctx.challengeIsActive)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_component_GuidancePrompts, { type: "ideas" })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showFavouritesOnly && _ctx.ideas?.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_Guidance, null, {
                            text: _withCtx(() => [
                              _createTextVNode(" You haven't selected any favourite ideas ")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("ul", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ideas, (idea) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: idea._id
                        }, [
                          _createElementVNode("label", null, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedIdeas) = $event)),
                              value: idea,
                              type: "checkbox",
                              class: "invisible"
                            }, null, 8, _hoisted_16), [
                              [_vModelCheckbox, _ctx.selectedIdeas]
                            ]),
                            _createVNode(_component_ChallengeIdea, {
                              idea: idea,
                              "is-selected": _ctx.isSelectedIdea(idea),
                              "start-editing-idea": _ctx.startEditingIdea,
                              "stop-editing-idea": _ctx.stopEditingIdea
                            }, null, 8, ["idea", "is-selected", "start-editing-idea", "stop-editing-idea"])
                          ])
                        ]))
                      }), 128))
                    ]),
                    (_ctx.challengeIsActive)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_AppButton, {
                            type: "secondary",
                            disabled: _ctx.hasEditedIdeas,
                            onClick: _ctx.showAddIdeaModal
                          }, {
                            iconBefore: _withCtx(() => [
                              _createVNode(_component_PlusIcon, { class: "mr-2 fill-current" })
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" Add Idea ")
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("p", _hoisted_18, [
                    _createTextVNode(" No ideas – "),
                    _createElementVNode("button", {
                      class: "text-cebai-primary",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showAddIdeaModal && _ctx.showAddIdeaModal(...args)))
                    }, " create one now "),
                    _createTextVNode(" or explore sparks and learning to add ideas ")
                  ]))
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_Ribbon, {
      class: "mt-16",
      "ribbon-type": "primary"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          (!_ctx.hasSelectedIdeas && !_ctx.hasPlan)
            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _hoisted_23))
            : (_ctx.hasEditedIdeas)
              ? (_openBlock(), _createElementBlock("p", _hoisted_24, " Save changes before creating plan "))
              : _createCommentVNode("", true),
          (_ctx.hasPlan)
            ? (_openBlock(), _createBlock(_component_AppButtonRouterLink, {
                key: 2,
                type: "primary",
                class: "whitespace-nowrap",
                disabled: _ctx.hasEditedIdeas,
                to: { name: 'challenge-saved-plan' }
              }, {
                iconAfter: _withCtx(() => [
                  _createVNode(_component_ArrowRightIcon, { class: "ml-2 stroke-current stroke-2" })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Your plan ")
                ]),
                _: 1
              }, 8, ["disabled"]))
            : (_openBlock(), _createBlock(_component_AppButton, {
                key: 3,
                type: "primary",
                class: "whitespace-nowrap",
                disabled: !_ctx.hasSelectedIdeas || _ctx.hasEditedIdeas,
                "is-loading": _ctx.isLoadingPlan,
                onClick: _ctx.handleCreatePlan
              }, {
                iconAfter: _withCtx(() => [
                  _createVNode(_component_ArrowRightIcon, { class: "ml-2 stroke-current stroke-2" })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Create plan ")
                ]),
                _: 1
              }, 8, ["disabled", "is-loading", "onClick"]))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Modal, {
      modelValue: _ctx.isShown.deleteIdeas,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isShown.deleteIdeas) = $event)),
      close: () => _ctx.closeModal('deleteIdeas')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalContent, {
          close: () => _ctx.closeModal('deleteIdeas'),
          title: "Delete ideas",
          class: "md:max-w-xl"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Editorial, null, {
              default: _withCtx(() => [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_AppButton, {
                    class: "mr-2",
                    type: "secondary",
                    onClick: _cache[7] || (_cache[7] = () => _ctx.closeModal('deleteIdeas'))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancel ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_AppButton, {
                    type: "danger",
                    onClick: _ctx.handleDeleteClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Delete")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["close"])
      ]),
      _: 1
    }, 8, ["modelValue", "close"]),
    _createVNode(_component_Modal, {
      modelValue: _ctx.isShown.downloadIdeas,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isShown.downloadIdeas) = $event)),
      close: () => _ctx.closeModal('downloadIdeas')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalContent, {
          close: () => _ctx.closeModal('downloadIdeas'),
          title: "Download ideas"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Download, {
              ideas: _ctx.selectedIdeas,
              "output-type": "ideas",
              "close-modal": () => _ctx.closeModal('downloadIdeas')
            }, {
              title: _withCtx(() => [
                _createTextVNode(" How would you like to download your ideas? ")
              ]),
              _: 1
            }, 8, ["ideas", "close-modal"])
          ]),
          _: 1
        }, 8, ["close"])
      ]),
      _: 1
    }, 8, ["modelValue", "close"]),
    _createVNode(_component_Modal, {
      modelValue: _ctx.isShown.addIdea,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isShown.addIdea) = $event)),
      close: () => _ctx.closeModal('addIdea')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalContent, {
          close: () => _ctx.closeModal('addIdea'),
          title: "Describe your idea"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CreateIdea, {
              "close-modal": () => _ctx.closeModal('addIdea')
            }, null, 8, ["close-modal"])
          ]),
          _: 1
        }, 8, ["close"])
      ]),
      _: 1
    }, 8, ["modelValue", "close"])
  ], 64))
}